import * as actionTypes from "./actiontypes";
import states from "./states";
import findIndex from "lodash/findIndex";
import isEmpty from "lodash/isEmpty";

const query_details = (state = states.query_details, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_CLUSTERS_STATE: {
      return {
        ...state,
        table_pagination: {
          ...state.table_pagination,
          current: action.payload
            ? action.payload
            : state.table_pagination.current
        }
      };
    }

    case actionTypes.UPDATE_QUERY_STATE: {
      return {
        ...state,
        ...action.payload
      }
    }

    case actionTypes.DATE_FILTER_RECEIVED:
      return {
        ...state,
        available_dates: action.payload
          ? action.payload
          : [...state.available_dates]
      };

    case actionTypes.CLUSTER_DATA_LOADING:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          cluster_data_loading: true
        }
      };

    case actionTypes.CLUSTER_DATA_RECEIVED: {
      return {
        ...state,
        cluster_data: action.payload
          ? { name: "root", children: action.payload }
          : { ...state.cluster_data },
        loaders: {
          ...state.loaders,
          cluster_data_loading: false,
          cluster_data_load_error: false
        }
      };
    }

    case actionTypes.CLUSTER_DATA_LOAD_ERROR:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          cluster_data_loading: false,
          cluster_data_load_error: true
        }
      };

    case actionTypes.TABLE_DATA_LOADING:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          table_data_loading: true
        }
      };

    case actionTypes.TABLE_DATA_RECEIVED:
      return {
        ...state,
        table_data: action.payload ? action.payload : [...state.table_data],
        table_pagination: {
          ...state.table_pagination,
          more_pages: action.payload.length === 10
        },
        loaders: {
          ...state.loaders,
          table_data_loading: false,
          table_data_load_error: false
        }
      };

    case actionTypes.TABLE_DATA_LOAD_ERROR:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          table_data_loading: false,
          table_data_load_error: true
        }
      };

    case actionTypes.UTTERANCES_DATA_LOADING:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          utterance_data_loading: true
        }
      };
    case actionTypes.UTTERANCES_DATA_RECEIVED: {
      let index = findIndex(state.utterance_data, {
        id: action.payload._id.ObjectId
      });
      let new_utterance_data;
      if (index !== -1) {
        new_utterance_data = [...state.utterance_data];
        new_utterance_data[index] = {
          ...new_utterance_data[index]
        };
      } else {
        new_utterance_data = [
          ...state.utterance_data,
          {
            id: action.payload._id.ObjectId,
            utterances: action.payload.uterrances,
            hasMore: action.payload.uterrances.length === 20
          }
        ];
      }
      return {
        ...state,
        utterance_data: action.payload
          ? new_utterance_data
          : [...state.utterance_data],
        loaders: {
          ...state.loaders,
          utterance_data_loading: false,
          utterance_data_load_error: false
        }
      };
    }

    case actionTypes.UTTERANCES_DATA_LOAD_ERROR:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          utterance_data_loading: false,
          utterance_data_load_error: true
        }
      };

    case actionTypes.MORE_UTTERANCES_RECEIVED: {
      if (!isEmpty(action.payload)) {
        let index = findIndex(state.utterance_data, {
          id: action.payload._id.ObjectId
        });
        let new_utterance_data;
        if (index !== -1) {
          new_utterance_data = [...state.utterance_data];
          new_utterance_data[index] = {
            ...new_utterance_data[index],
            utterances: new_utterance_data[index].utterances.concat(
              action.payload.uterrances
            ),
            hasMore: action.payload.uterrances.length === 20
          };
        } else {
          new_utterance_data = [
            ...state.utterance_data,
            {
              id: action.payload._id.ObjectId,
              utterances: action.payload.uterrances,
              hasMore: action.payload.uterrances.length === 20
            }
          ];
        }
        return {
          ...state,
          utterance_data: action.payload
            ? new_utterance_data
            : [...state.utterance_data]
        };
      } else return state;
    }
    default:
      return state;
  }
};

export default query_details;



// WEBPACK FOOTER //
// ./src/data/redux/query_details/reducers.js